<div class="card">
  <div class="card-body">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-1">
      <h4 class="header-title mb-0">
        {{ 'channel.voipRamais.title' | translate }}
        @if (ramais.length) {
          <span class="badge bg-soft-primary text-primary rounded-pill ms-1">
            {{ ramais.length }}
          </span>
        }
      </h4>
      <button class="btn btn-primary btn-sm" (click)="newRamal()">
        <i class="ri-add-line me-1"></i> {{ 'channel.voipRamais.newRamal' | translate }}
      </button>
    </div>
    <p class="text-muted mb-3">
      {{ 'channel.voipRamais.description' | translate }}
    </p>

    <!-- Table -->
    @if (ramais.length) {
      <div class="table-responsive">
        <table class="table table-centered table-hover mb-0">
          <thead>
            <tr>
              <th class="text-primary-emphasis">{{ 'channel.voipRamais.ramalSipLabel' | translate }}</th>
              <th class="text-primary-emphasis">{{ 'channel.voipRamais.attendantHeader' | translate }}</th>
              <th class="text-primary-emphasis">{{ 'channel.voipRamais.statusHeader' | translate }}</th>
              <th><span class="sr-only"></span></th>
            </tr>
          </thead>
          <tbody>
            @for (ramal of ramais; track ramal.sipUsername) {
              <tr>
                <td class="fw-semibold">
                  {{ ramal.sipUsername }}
                  @if (ramal.sipUsername === defaultExtension) {
                    <span
                      class="badge bg-soft-info text-info ms-1"
                      [title]="'channel.voipRamais.inboundBadgeTitle' | translate"
                    >
                      {{ 'channel.voipRamais.inboundBadge' | translate }}
                    </span>
                  }
                </td>
                <td>{{ ramal.user?.name ?? "—" }}</td>
                <td>
                  @if (ramal.activated) {
                    <span class="badge bg-soft-success text-success">
                      {{ 'channel.voipRamais.statusActive' | translate }}
                    </span>
                  } @else {
                    <span class="badge bg-soft-danger text-danger">
                      {{ 'channel.voipRamais.statusInactive' | translate }}
                    </span>
                  }
                </td>
                <td class="text-center">
                  <div class="d-flex justify-content-end">
                    <button
                      class="btn btn-dropdown-list"
                      [matMenuTriggerFor]="menu"
                      type="button"
                      (click)="$event.stopPropagation()"
                      (mousedown)="$event.stopPropagation()"
                    >
                      <i
                        class="mdi mdi-dots-vertical text-primary-emphasis"
                      ></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button
                        mat-menu-item
                        tabindex="0"
                        (click)="editRamal(ramal)"
                      >
                        {{ 'channel.voipRamais.edit' | translate }}
                      </button>
                      @if (ramal.sipUsername !== defaultExtension) {
                        <button
                          mat-menu-item
                          tabindex="0"
                          (click)="setAsDefault(ramal)"
                        >
                          {{ 'channel.voipRamais.setAsInbound' | translate }}
                        </button>
                      }
                      <button
                        mat-menu-item
                        tabindex="0"
                        (click)="resync(ramal)"
                      >
                        {{ 'channel.voipRamais.resyncCredentials' | translate }}
                      </button>
                      <button
                        mat-menu-item
                        tabindex="0"
                        (click)="remove(ramal)"
                      >
                        {{ 'channel.channelConfig.remove' | translate }}
                      </button>
                    </mat-menu>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <empty-records-component
        [icon]="'ri-phone-line'"
        [message]="'channel.voipRamais.emptyMessage' | translate"
        [subMessage]="'channel.voipRamais.emptySubMessage' | translate"
        [labelButton]="'channel.list.addButton' | translate"
        (emitEvent)="newRamal()"
      />
    }
  </div>
</div>
